module.exports = __webpack_public_path__ + "static/media/herramienta-naranja.469f605b.svg";